import { userConstants } from '../_constants';
import { userService } from '../_services';
import { alertActions } from './';
import { history } from '../_helpers';

export const userActions = {
    login,
    logout,
    getEntitlements,
    changePassword,
    downloadCS2Specs
    //delete: _delete
};

function login(username, password, from) {
    return dispatch => {
        dispatch(request({ username }));
        console.log("user action login called and calling userservice login... from: " + JSON.stringify(from) );
        userService.login(username, password)
            .then(
                user => { 
                	console.log("success came after login service called");
                    //dispatch(getEntitlements(user.shortName));
                    dispatch(success(user));
                    dispatch(getVersion());
                    /* - from object contains the url path 
                     * - if someone wants to access specific application 
                     * - we redirect to login path to first login
                     * - after login it redirect to specific application location 
                     * - but application can only open if it has entitlements
                     * - entitlements only call from application path
                     * - therefore we redirecting it to the application path and overwriting with application from object.
                     */
                    from.pathname = "/applications"
                    history.push(from);
                },
                error => {
                    console.log("error came after login service called");
                    dispatch(failure(error.toString()));

                    if (error.message == 'Network Error') {
                         dispatch(alertActions.error(error.message + ". Please, reach out to Administractor!"));
                         
			        } else if ([401].includes(error.response.status)) {
                        const { data } = error.response;
                        dispatch(alertActions.error(data.message + " : " + data.detailMessage));
				    } else if ([404, 500].includes(error.response.status)) {
                        dispatch(alertActions.error("Internal Error - " + error.response.status + ". Please reach out to Administrator!"));
				    }
                    
                }
            );
    };

    function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function logout() {
    userService.logout();
    return { type: userConstants.LOGOUT };
}

function register(user) {
    return dispatch => {
        dispatch(request(user));

        userService.register(user)
            .then(
                user => { 
                    dispatch(success());
                    history.push('/login');
                    dispatch(alertActions.success('Registration successful'));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(user) { return { type: userConstants.REGISTER_REQUEST, user } }
    function success(user) { return { type: userConstants.REGISTER_SUCCESS, user } }
    function failure(error) { return { type: userConstants.REGISTER_FAILURE, error } }
}

function getAll() {
    return dispatch => {
        dispatch(request());

        userService.getAll()
            .then(
                users => dispatch(success(users)),
                error => dispatch(failure(error.toString()))
            );
    };

    function request() { return { type: userConstants.GETALL_REQUEST } }
    function success(users) { return { type: userConstants.GETALL_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GETALL_FAILURE, error } }
}

function getEntitlements(userId) {
    return dispatch => {
        dispatch(request());

        userService.getEntitlements(userId)
            .then(
                entitlements => {
                	dispatch(success(entitlements));
                },
                error => {
                    if (!error.message == 'Network Error') {
                        dispatch(failure(error.toString() + " - " + error.response.data.message));
                        dispatch(alertActions.error(error.response.data.message + " - " + error.response.status));
                    }
                    userService.logout();
                    
                }
            );
    };

    function request() { return { type: userConstants.GET_ENTITLEMENT_REQUEST } }
    function success(entitlements) { return { type: userConstants.GET_ENTITLEMENT_SUCCESS, entitlements } }
    function failure(error) { return { type: userConstants.GET_ENTITLEMENT_FAILURE, error } }
}

function changePassword(inputs) {

    return dispatch => {
        dispatch(request());

        userService.changePassword(inputs)
            .then(
                status => { 
                    dispatch(success(status));
                    //var message = executions.message == 'Fail' ? result.response.error[0].$.type : result.response.success[0].$.type;
                    dispatch(alertActions.success(status.message ));       
                },
                error => {
                    dispatch(failure(inputs, error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    };

    function request(inputs) { return { type: userConstants.CHANGE_PASSWORD_REQUEST, inputs } }
    function success(status) { return { type: userConstants.CHANGE_PASSWORD_SUCCESS, status } }
    function failure(inputs, error) { return { type: userConstants.CHANGE_PASSWORD_FAILURE, inputs, error } }
}

function getVersion() {

   
    return dispatch => {
        
         userService.getVersion()
            .then(
                version => dispatch(success(version)),
                error => dispatch(failure(error.toString()))
            )
    };

    function request() { return { type: userConstants.GET_VERSION_REQUEST } }
    function success(version) { return { type: userConstants.GET_VERSION_SUCCESS, version } }
    function failure(error) { return { type: userConstants.GET_VERSION_FAILURE, error } }
}

function downloadCS2Specs(userId) {

    userService.downloadEFPCS2Specs(userId);

  /*  return dispatch => {

        userService.downloadEFPCS2Specs(userId)
            .then(
                status => dispatch(success()),
                error => dispatch(failure(userId, error.toString()))
            );
    };

    function success() { return { type: userConstants.CS2_SPECS_DOWNLOAD_SUCCESS } }
    function failure(id, error) { return { type: userConstants.CS2_SPECS_DOWNLOAD_FAILURE, id, error } } */
}
       
// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    return dispatch => {
        dispatch(request(id));

        userService.delete(id)
            .then(
                user => dispatch(success(id)),
                error => dispatch(failure(id, error.toString()))
            );
    };

    function request(id) { return { type: userConstants.DELETE_REQUEST, id } }
    function success(id) { return { type: userConstants.DELETE_SUCCESS, id } }
    function failure(id, error) { return { type: userConstants.DELETE_FAILURE, id, error } }
}